module.exports = __webpack_public_path__ + "static/media/josue_mejia_13.58c51f62.jpg";